import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsDriver,
  UpdateNpsDriver,
  FiltersNpsDrivers
} from '@/Network/Types/Requests/NpsRequests'
import { NpsDriverResponse, ListNpsDriversResponse } from '@/Network/Types/Responses/NpsResponses'

export default class NpsDriverService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/drivers'
  }

  async create(payload: CreateNpsDriver): Promise<NpsDriverResponse> {
    try {
      const response = await request.post<NpsDriverResponse>(this.getCompletePath(), payload)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível criar o motivador.')
    }
  }

  async update(driverId: number, payload: UpdateNpsDriver): Promise<NpsDriverResponse> {
    try {
      const response = await request.put<NpsDriverResponse>(
        `${this.getCompletePath()}/${driverId}`,
        payload
      )
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível atualizar o motivador.')
    }
  }

  async getById(driverId: number): Promise<NpsDriverResponse> {
    try {
      const response = await request.get<NpsDriverResponse>(`${this.getCompletePath()}/${driverId}`)
      return response.data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar o motivador.')
    }
  }

  async toggleActive(driverId: number, companyId: number): Promise<NpsDriverResponse> {
    try {
      const response = await request.patch(
        `${this.getCompletePath()}/${driverId}/toggle-active?companyId=${companyId}`,
        {}
      )
      return response.data as NpsDriverResponse
    } catch (e) {
      throw this.handleError(e, 'Não foi possível alterar o status do motivador.')
    }
  }

  async delete(driverId: number): Promise<void> {
    try {
      await request.delete(`${this.getCompletePath()}/${driverId}`)
    } catch (e) {
      throw this.handleError(e, 'Não foi possível excluir o motivador.')
    }
  }

  async list(filters?: FiltersNpsDrivers): Promise<ListNpsDriversResponse> {
    try {
      const { data } = await request.get<ListNpsDriversResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os motivadores.')
    }
  }
}
